import { ThemeAppService } from '../services/app.service';
export class ApplicationController implements aboTheme.IApplication {

    public isMessageOpen: boolean;
    public isConfigOpen: boolean;
    public layout: aboTheme.ILayout;
    public name: string;
    public author: string;
    public version: string;
    public year: number;

    constructor(private ThemeService: aboTheme.IThemeService, private ThemeAppService: ThemeAppService) {
        'ngInject';

        this.name = 'Urban';
        this.author = 'Nyasha';
        this.version = '1.0.0';
        this.year = (new Date()).getFullYear();

        this.layout = ThemeService.getLayout();
    }

    public $onInit = () => {
    }

};

export const application = {
    controller: ApplicationController,
    template: require('./application.html')
};


// WEBPACK FOOTER //
// ./~/@abosol/theme/src/app/main/application.component.ts